module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN204_705946128.e80eedd0.png";